module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-banner-c7e84656ea1611c871713f368197a486.jpg";